
const FluidLineIcon = () => {
  return (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="6" viewBox="0 0 18 6" fill="none">
		<circle cx="3" cy="3" r="3" fill="#FF6699"/>
		<path d="M18 2.99333L4.99851 2.99054" stroke="#FF6699" stroke-width="2"/>
  	</svg>
  )
}

export default FluidLineIcon